/* eslint-disable compat/compat */
class ProductBis extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.listeners.add(this.els.form.element, 'submit', (e) => {
      e.preventDefault()
      this.onFormSubmission()
    })
  }

  onFormSubmission () {
    let variantId = this.els?.form?.element?.dataset?.variantId

    if (new URL(window.location).searchParams.has('variant')) {
      variantId = Number(new URL(window.location).searchParams.get('variant'))
    }

    const emailAddress = this.els?.email?.element?.value

    if (!emailAddress) {
      return
    }

    this.KlaviyoSubmission(variantId, emailAddress)
  }

  async KlaviyoSubmission (variantId, emailAddress) {
    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: `${emailAddress}`,
              },
            },
          },
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantId}`,
            },
          },
        },
      },
    }

    const request = await fetch(
      `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.theme.klaviyo.apiKey}`,
      {
        method: 'POST',
        headers: {
          revision: '2023-12-15',
          'content-type': 'application/json',
        },
        body: JSON.stringify(payload),
      },
    )

    if (!request.ok) {
      console.error(request)
    } else {
      this.showSuccess()
    }
  }

  showSuccess () {
    this.els.success.element.setAttribute('aria-hidden', false)
    this.els.content.element.setAttribute('aria-hidden', true)
  }
}

if (!customElements.get('product-bis')) {
  customElements.define('product-bis', ProductBis)
}
